module.exports = __webpack_public_path__ + "static/media/sale.5bdc3e83.png";